import * as React from "react";
import { useState } from "react";
import jpg_images from "url:../../images/*.jpg";
import resumePdf from "url:../../pdf/resume.pdf";
import { topData } from "../data";
import { getAssetUrl, resolveAssetMap } from "../asset";
import { useLang } from "../lang";
import { getLocalizedText } from "../util";

const Top: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { langEn } = useLang();
  const images = resolveAssetMap(jpg_images);
  const photoUrl = getAssetUrl(images, topData.photo);
  const topLinks = (topData.links || [])
    .map((link) => ({
      title: getLocalizedText(link.title, langEn),
      url: getLocalizedText(link.url, langEn),
    }))
    .filter((link) => link.title && link.url);

  return (
    <div id="top-profile" className="ftco-section">
      <div className="container justify-content-center pt-3">
        <div className="row text-left align-items-start top-profile-row">
          <div className="col-md-3 pt-3 top-profile-photo-col">
            <div
              className="d-md-none top-mobile-intro"
              dangerouslySetInnerHTML={{
                __html: getLocalizedText(topData.selfIntroduction, langEn) || "",
              }}
            ></div>
            {photoUrl ? (
              <img src={photoUrl} className="bd-placeholder-img img-fluid author-photo" />
            ) : (
              ""
            )}
          </div>
          <div className="col-md-9 pt-3 top-profile-body-col">
            <div className="h6 mt-3 mb-4 top-short-bio-block">
              <a
                href=""
                role="button"
                onClick={(e) => {
                  e.preventDefault();
                  setIsOpen(!isOpen);
                }}
              >
                {isOpen ? "« close" : "Short Bio »"}
              </a>

              <div className={`mt-2 top-bio ${isOpen ? "is-open" : ""}`} id="short-bio">
                <div className="card card-body text-secondary">
                  <small>{topData.bio}</small>
                </div>
              </div>
            </div>

            <p className="h6 top-actions">
              <a
                href={resumePdf}
                className="btn btn-primary btn-sm link-arrow"
                target="_blank"
                rel="noreferrer"
              >
                Curriculum Vitae
              </a>
              {topLinks.map((link) => (
                <a
                  key={`${link.title}-${link.url}`}
                  href={link.url}
                  className="btn btn-primary btn-sm link-arrow"
                  target="_blank"
                  rel="noreferrer"
                >
                  {link.title}
                </a>
              ))}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Top;
